module.exports = __webpack_public_path__ + "static/how-to-partner-mobile-ccc18c5a6d42d15cff6e20fd3693b9b9.svg";